import { render, staticRenderFns } from "./WidgetBuilder.vue?vue&type=template&id=dfadccc8&scoped=true&"
import script from "./WidgetBuilder.vue?vue&type=script&lang=js&"
export * from "./WidgetBuilder.vue?vue&type=script&lang=js&"
import style0 from "./WidgetBuilder.vue?vue&type=style&index=0&id=dfadccc8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfadccc8",
  null
  
)

export default component.exports